import React from "react";
import { Link } from "react-router-dom";
import { API_BASE, toUrl } from "../../lib/config";
type CardItem = {
  id: string;
  image: string;
  title: string;
  text: string;
  link?: string;
  bg: "green" | "mint"; // alt bloğun rengi
};

const FeatureStrip: React.FC = () => {
  // Dummy veriler (artık API'den dolduruluyor)
  // const cards: CardItem[] = [
  //   { id: "c1", image: imgDoctors, title: "Hekimlerimiz", text: "...", link: "/hekimler", bg: "green" },
  //   { id: "c2", image: imgBlood,   title: "Tıbbi Birimlerimiz", text: "...", link: "/tibbi-birimler", bg: "mint" },
  //   { id: "c3", image: imgER,      title: "Özel Sigortalar", text: "...", link: "/anlasmali-sigortalar", bg: "green" },
  // ];

  
  const resolveImageUrl = (u?: string) => {
    if (!u) return '';
    return /^https?:\/\//i.test(u) ? u : toUrl(u);
  };

  const ImgWithFallback: React.FC<{ src?: string; alt?: string; style?: React.CSSProperties }> = ({ src, alt = '', style }) => {
    const raw = src || '';
    const abs = resolveImageUrl(raw);
    const [current, setCurrent] = React.useState(abs);
    return (
      <img
        src={current}
        alt={alt}
        style={style}
        crossOrigin="anonymous"
        onError={(e) => {
          const cur = e.currentTarget.getAttribute('src') || '';
          const next = cur === abs ? raw : abs;
          if (next && next !== cur) e.currentTarget.src = next;
        }}
      />
    );
  };
  const [cards, setCards] = React.useState<CardItem[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setLoading(true); setError('');
        const res = await fetch(toUrl('/api/feature-strip'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const mapped: CardItem[] = (Array.isArray(data) ? data : [])
          .filter((x: any) => x && (x.isActive !== false))
          .sort((a: any, b: any) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0))
          .map((it: any) => ({
            id: it.id,
            image: resolveImageUrl(it.image || ''),
            title: it.title || '',
            text: it.text || '',
            link: it.link || '#',
            bg: (it.bg === 'mint' ? 'mint' : 'green'),
          }));
        if (!cancelled) setCards(mapped);
      } catch (e: any) {
        if (!cancelled) setError(e?.message || '');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [API_BASE]);

  return (
    <section className="feature-strip">
      <div className="container">
        <div className="feature-grid">
          {cards.map((c) => (
            <article key={c.id} className={`feature-card is-${c.bg}`}>
              {/* Üst görsel */}
              <div className="feature-media" aria-hidden="true" style={{ minHeight: 200 }}>
                <ImgWithFallback
                  src={c.image}
                  alt=""
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: 0 }}
                />
              </div>

              {/* Alt renkli blok */}
              <div className="feature-body">
                <h3 className="feature-title">{c.title}</h3>
                <span className="feature-accent" aria-hidden="true" />
                <p className="feature-text">{c.text}</p>

                <div className="feature-cta-wrap">
                  <Link to={c.link || "#"} className="feature-cta">
                    <span>DAHA FAZLA</span>
                    <i className="bi bi-chevron-right" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureStrip;
